<template>
  <div style="margin-top:60px" >
    <b-row style="justify-content: center">
      <b-col cols="8">
        <b-form-group>
          <div style="display: inline-flex">
            <b-form-radio name="some-radios" value="A">Company</b-form-radio>
            <b-form-radio name="some-radios" value="B">Individual</b-form-radio>
          </div>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Search*:"
        >
          <b-form-input
            v-model="$v.form.search.$model"
            :state="$v.form.search.$dirty ? !$v.form.search.$error : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Country (Corporate Address)*:"
        >
          <b-form-select
            v-model="$v.form.selectCountry.$model"
            :state="
              $v.form.selectCountry.$dirty
                ? !$v.form.selectCountry.$error
                : null
            "
            :options="optionsCountry"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Third Party Email*:"
        >
          <b-form-input
            type="email"
            v-model="$v.form.email.$model"
            :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Business Unit*:"
        >
          <b-form-select
            v-model="$v.form.businessUnit.$model"
            :state="
              $v.form.businessUnit.$dirty ? !$v.form.businessUnit.$error : null
            "
            :options="optionsBusinessUnit"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Country of Project*:"
        >
          <b-form-select
            v-model="$v.form.countryProjects.$model"
            :state="
              $v.form.countryProjects.$dirty
                ? !$v.form.countryProjects.$error
                : null
            "
            :options="optionsCountryProjects"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Type of Third Party*:"
        >
          <b-form-select
            v-model="$v.form.thirdParty.$model"
            :state="
              $v.form.thirdParty.$dirty ? !$v.form.thirdParty.$error : null
            "
            :options="optionsThirdParty"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Amount of Project*:"
        >
          <b-form-select
            v-model="$v.form.amountOfProjects.$model"
            :state="
              $v.form.amountOfProjects.$dirty
                ? !$v.form.amountOfProjects.$error
                : null
            "
            :options="optionsAmountOfProjects"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Length of Business Relationship*:"
        >
          <b-form-select
            v-model="$v.form.lenghtBusinessRelationship.$model"
            :state="
              $v.form.lenghtBusinessRelationship.$dirty
                ? !$v.form.lenghtBusinessRelationship.$error
                : null
            "
            :options="optionsLenghtBusinessRelationship"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Nature of Client (Public - Private)*:"
        >
          <b-form-select
            v-model="$v.form.natureOfClients.$model"
            :state="
              $v.form.natureOfClients.$dirty
                ? !$v.form.natureOfClients.$error
                : null
            "
            :options="optionsNatureOfClients"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Previous Relationship with Partner*:"
        >
          <b-form-select
            v-model="$v.form.relationWithClients.$model"
            :state="
              $v.form.relationWithClients.$dirty
                ? !$v.form.relationWithClients.$error
                : null
            "
            :options="optionsRelationWithClients"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          class="my-2"
          label-cols-sm="3"
          label-cols-lg="4"
          label="Justification of the Association*:"
        >
          <b-form-textarea
            id="textarea"
            v-model="$v.form.justification.$model"
            :state="
              $v.form.justification.$dirty
                ? !$v.form.justification.$error
                : null
            "
            placeholder="Justification of the association"
            rows="2"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <div class="mt-4">
          <BulkUpload />
        </div>
      </b-col>
      <b-col class="text-left" cols="2">
        <b-btn
          @click="onSubmit"
          variant="success"
          style="background: #3ddc97; width: 90px"
        >
          Next <b-icon icon="arrow-right-short"></b-icon>
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BulkUpload from "../../pages/employeeNew/manageEmployee/bulkUploadComponent.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
export default {
  name: "searchForm",
  mixins: [validationMixin],

  components: {
    BulkUpload,
  },
  data() {
    return {
      form: {
        search: null,
        selectCountry: null,
        email: null,
        businessUnit: null,
        countryProjects: null,
        thirdParty: null,
        amountOfProjects: null,
        lenghtBusinessRelationship: null,
        natureOfClients: null,
        relationWithClients: null,
        justification: null,
      },
      optionsCountry: [
        { value: "Pakistan", text: "Pakistan" },
        { value: "India", text: "India" },
      ],
      optionsThirdParty: [
        { value: "Agents", text: "Agents" },
        { value: "business", text: "Business" },
      ],
      optionsRelationWithClients: [
        { value: "3", text: "3 years" },
        { value: "6", text: "6 years" },
      ],
      optionsAmountOfProjects: [
        { value: "10M", text: "10M" },
        { value: "50M", text: "10M-50M" },
      ],
      optionsLenghtBusinessRelationship: [
        { value: "1", text: "1 Year" },
        { value: "2", text: "2 Year" },
      ],
      optionsNatureOfClients: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
      ],
      optionsCountryProjects: [
        { value: null, text: "Please select" },
        { value: "Pakistan", text: "Pakistan" },
        { value: "India", text: "India" },
      ],
      optionsBusinessUnit: [
        { value: "Airports", text: "Airports" },
        { value: "Corporate", text: "Corporate" },
      ],
    };
  },
  validations: {
    form: {
      search: { required },
      selectCountry: { required },
      email: { required,email },
      businessUnit: { required },
      countryProjects: { required },
      thirdParty: { required },
      amountOfProjects: { required },
      lenghtBusinessRelationship: { required },
      natureOfClients: { required },
      relationWithClients: { required },
      justification: { required },
    },
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.$store.state.tabIndex++;
        this.$store.state.reviewTab = false;
        // // console.log(this.$store.state.tabIndex);
      }
        //  this.$store.state.tabIndex++;
        // this.$store.state.reviewTab = false;
    },
 
  },
};
</script>

<style>
</style>